import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isValid", "isError", "errorMessage", "fullWidth", "label", "note", "hideNoteSpace", "options", "onChange", "value", "ownAnswer"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Field } from '@vtblife/uikit/dist/legacy';
import React, { useCallback } from 'react';
import { createFormikComponent, mapFieldToInputProps } from '@vtblife/uikit-formik';
import { CheckboxComponent, OwnAnswerCheckbox } from '../formik-checkbox-group-field/formik-checkbox-group-field';
var RadioGroupFilteredProps = function RadioGroupFilteredProps(props) {
  // Skip some of params to be passed by Field to RadioGroup
  var isValid = props.isValid,
    isError = props.isError,
    errorMessage = props.errorMessage,
    fullWidth = props.fullWidth,
    label = props.label,
    note = props.note,
    hideNoteSpace = props.hideNoteSpace,
    options = props.options,
    onChange = props.onChange,
    value = props.value,
    ownAnswer = props.ownAnswer,
    rest = _objectWithoutProperties(props, _excluded);
  var getCheckboxOnChange = useCallback(function (value) {
    return function (_checked, event) {
      if (onChange) {
        onChange(value, event);
      }
    };
  }, [onChange]);
  var items = options.map(function (option, i) {
    return React.createElement(CheckboxComponent, _objectSpread(_objectSpread({}, rest), {}, {
      key: i,
      label: option.label,
      onChange: getCheckboxOnChange(option.value),
      radio: true,
      value: value == option.value
    }));
  });
  return React.createElement("div", null, items, ownAnswer && React.createElement(OwnAnswerCheckbox, _objectSpread(_objectSpread({}, rest), {}, {
    key: 'ownAnswer',
    onTextChange: function onTextChange(_ref) {
      var currentValue = _ref.currentValue,
        event = _ref.event;
      onChange(currentValue, event);
    },
    getCheckboxOnChange: getCheckboxOnChange,
    getActive: function getActive(text) {
      return value === text;
    },
    radio: true
  })));
};
export var RadioGroupField = Field(RadioGroupFilteredProps, false, false);
export var FormikRadioGroupField = createFormikComponent(RadioGroupField, mapFieldToInputProps);